function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import MenuPanel from './MenuPanel';
import Button from '../Button/index';
import isUnstable from '../utils/isUnstable';

var DropdownMenu = function DropdownMenu(_ref) {
  var buttonText = _ref.buttonText,
      children = _ref.children,
      disabled = _ref.disabled,
      panelHeight = _ref.panelHeight,
      panelWidth = _ref.panelWidth;
  isUnstable('DropdownMenu');

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown maxwidth-100p"
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, buttonText), /*#__PURE__*/React.createElement("div", {
    className: "position-relative width-100p"
  }, /*#__PURE__*/React.createElement(MenuPanel, {
    height: panelHeight,
    width: panelWidth,
    isOpen: isOpen
  }, Children.map(children, function (child) {
    return cloneElement(child, {
      disabled: disabled
    });
  }))));
};

DropdownMenu.propTypes = {
  buttonText: PropTypes.string.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  panelHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  panelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
DropdownMenu.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DropdownMenu",
  "props": {
    "buttonText": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "panelHeight": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": ""
    },
    "panelWidth": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": ""
    }
  }
};
export default DropdownMenu;